import { Table } from "react-bootstrap";
import "../App.css";

// export default function CustomTable({ 
//   headers = [], 
//   children , 
//   className = "", 
//   headclassName = "",
//   striped = false,
//   hover = false,
//   bordered = false,
//   responsive = false
// }) {
//   return (
//     <Table 
//     striped={striped}
//     hover={hover}
//     bordered={bordered}
//     responsive={responsive}
//     className={`align-middle ${className}`}
//     >
//       <thead className={headclassName}>
//         {/* <tr>
//           {headers.map((h) => (
//             <th key={h}>{h}</th>
//           ))}
//         </tr> */}
//          <tr>
//           {headers.map((h, idx) => {
//             const isObj = typeof h === "object" && h !== null;
//             const label = isObj ? h.label : h;
//             const thClass = isObj ? h.className : "";
//             return (
//               <th key={isObj ? h.label ?? idx : h} className={thClass}>
//                 {label}
//               </th>
//             );
//           })}
//         </tr>
//       </thead>
//       <tbody>{children}</tbody>
//     </Table>
//   );
// }

export default function CustomTable({
  headers = [],
  children,
  className = "",
  theadClassName = "",
  striped = false,
  hover = false,
  bordered = false,
  responsive = true,
}) {
  return (
    <Table
      striped={striped}
      hover={hover}
      bordered={bordered}
      responsive={responsive}
      className={`align-middle ${className}`}
    >
      <thead className={theadClassName}>
        <tr className="celltable">
          {headers.map((h, idx) => {
            const isObj = typeof h === "object" && h !== null;
            const label = isObj ? h.label : h;
            const thClass = isObj ? h.className : "";
            const thStyle = isObj ? h.style : undefined;
            return (
              <th key={isObj ? h.label ?? idx : h} className={thClass} style={thStyle}>
                {label}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </Table>
  );
}